import { Button, ButtonBase, CircularProgress } from "@mui/material";
import { Checkbox, Input, Select, Tabs } from "antd";
import { CheckCircleFilled } from '@ant-design/icons';
import ImageInput from "./ImageInput";
import { useState } from "react";
import CropPopup from "./CropPopUp";
import { useRef } from "react";
import ContactCard from "./ContactCard";
import {
    Controller,
    FormProvider,
    useFieldArray,
    useForm,
} from "react-hook-form";
import { useEffect } from "react";
import { useContext } from "react";
import { AuthenticationContext } from "../../App";
import dayjs from "dayjs";
import countryCode from "../../config/countryCode.json";
import axios from "../../axios/axios";
import { IMAGE_BASE_URL } from "../../common/Constants";
import { toast } from "react-toastify";
import LoaderComp from "../../components/LoaderComp";
import { IoMdArrowDropdown } from "react-icons/io";
async function dataURItoBlob(url) {
    return await (await fetch(url)).blob();
}
const rat_items = [
    {
        key: 0,
        label: `In-House`,
    },
    {
        key: 1,
        label: `Flooring`,
    },
];
let searchTimeout = null;

const Profile = () => {
    const { authData } = useContext(AuthenticationContext);

    const [pin, setPin] = useState("••••");
    const [seconds, setSeconds] = useState(0);
    const [disabled, setDisabled] = useState(false);
    const [loading, setLoading] = useState(false);

    const [priorities, setPriorities] = useState([
        { value: '', error: false },
        { value: '', error: false },
        { value: '', error: false },
    ]);

    const [agentId, setAgentId] = useState([])
    const [isFormEdit, setIsFormEdit] = useState(false);

    const handleChange = (index, newValue) => {
        const updated = [...priorities];

        updated[index].value = newValue;
        updated[index].agent_id = null;     //for tickmark
        setPriorities(updated);
    };

    const getLabel = (index) => {
        return `Default Agent ${index + 1}`;
    };

    useEffect(() => {
        if (seconds > 0) {
            const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
            return () => clearTimeout(timer);
        } else {
            setDisabled(false);
            setPin("••••");
        }
    }, [seconds]);

    const formatTime = () => {
        const min = String(Math.floor(seconds / 60)).padStart(2, "0");
        const sec = String(seconds % 60).padStart(2, "0");
        return `${min}:${sec}`;
    };

    //GeneratePin
    const handleResendPin = async () => {
        const newPin = Math.floor(1000 + Math.random() * 9000).toString();
        setPin(newPin);
        setSeconds(180);
        setDisabled(true);
        try {
            const response = await axios.post('generate-pin', {
                security_pin: newPin,
            });
        } catch (error) {
            console.error("Error storing PIN:", error);
        }
    };
    const methods = useForm({
        defaultValues: {
            name: "",
            email: "",
            uenNumber: "",
            faxNumber: "",
            phoneNumber: "",
            featured: "",
            addressLine1: "",
            addressLine2: "",
            countryCode: "",
            country: "",
            postalCode: "",
            contacts: [
                {
                    name: "",
                    designation: "",
                    countryCode: "",
                    phoneNumber: "",
                    email: "",
                    smsNotification: false,
                    emailNotification: false,
                    isPrimary: true,
                },
            ],
        },
    });
    const {
        control,
        setValue,
        getValues,
        handleSubmit,
        register,
        clearErrors,
        watch,
        trigger,
        reset,
        formState: { errors },
    } = methods;
    const [imgErr, setImgErr] = useState(false);
    const [subBtnLoad, setsubBtnLoad] = useState(false);
    const imgPosRef = useRef(null);
    const pwdPosRef = useRef(null);
    const [productIcon, setProductIcon] = useState(null);
    const [showCrop, setShowCrop] = useState(false);
    const [croppedImage, setCroppedImage] = useState(false);
    const [image, setImage] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [resPassword, setresPassword] = useState(false);
    const [pwdData, setpwdData] = useState({
        password: "",
        cnfirm_pwd: "",
        pwdError: false,
        cpwdError: false,
    });
    const [ratingsTab, setratingsTab] = useState(0);
    const onImageChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            setShowCrop(true);
            setImage(URL.createObjectURL(event.target.files[0]));
        }
    };
    const submitFormData = async (data) => {
        if (!imgErr && !pwdData.pwdError && !pwdData.cpwdError) {

            setsubBtnLoad(true);
            const postData = {
                ...data,
                icon: productIcon,
            };
            try {
                const resp = await axios.put("/profile/update", postData, {
                    headers: {
                        Authorization: `Bearer ${authData?.token}`,
                    },
                });
                setsubBtnLoad(false);
                if (resp?.data?.resp_code === 200) {
                    setEditMode(false);
                    setresPassword(false);
                    setpwdData((prev) => ({
                        ...prev,
                        pwdError: false,
                        password: "",
                        cnfirm_pwd: "",
                        cpwdError: false,
                    }));
                    window.scrollTo({ top: 0 });
                    toast.success(resp.data?.message);
                }
            } catch (err) {
                setsubBtnLoad(false);
                const temp = Object.values(err?.response?.data?.errors);
                const ErrorMsg =
                    temp !== undefined && temp !== null && temp?.length > 0
                        ? temp[0]
                        : "Profile not updated..!";
                console.log("ERROR", ErrorMsg);
                toast.error(ErrorMsg);
            } finally {
                setsubBtnLoad(false);
            }
        }
    };
    const clickSubmitData = (act) => {
        let err = 0;
        setImgErr(false);
        setpwdData((prev) => ({
            ...prev,
            cpwdError: false,
            pwdError: false,
        }));
        if (!croppedImage && productIcon === null) {
            setImgErr(true);
            if (imgPosRef.current) {
                imgPosRef.current.scrollIntoView({
                    block: "start",
                    behavior: "smooth",
                });
            }
            err++;
        }
        if (resPassword) {
            if (pwdData.password === "") {
                setpwdData((prev) => ({
                    ...prev,
                    pwdError: true,
                }));
                if (pwdPosRef.current) {
                    pwdPosRef.current.scrollIntoView({
                        block: "start",
                        behavior: "smooth",
                    });
                }
                err++;
            }
            if (pwdData.cnfirm_pwd === "") {
                setpwdData((prev) => ({
                    ...prev,
                    cpwdError: true,
                }));
                if (pwdPosRef.current) {
                    pwdPosRef.current.scrollIntoView({
                        block: "start",
                        behavior: "smooth",
                    });
                }
                err++;
            }
        }
        if (err === 0 && act === "top_edit") {
            handleSubmit(submitFormData)();
        }
    };
    useEffect(() => {
        if (authData) {

            setValue("name", authData.name);
            setValue("featured", authData.featured);
            setValue("phoneNumber", authData.phoneNumber);
            setValue("postalCode", authData.postalCode);
            setValue("uenNumber", authData.uenNumber);
            setValue("faxNumber", authData.faxNumber);
            setValue("email", authData.email);
            setValue("countryCode", authData.countryCode);
            setValue("country", authData.country);
            setValue("addressLine1", authData.addressLine1);
            setValue("addressLine2", authData.addressLine2);
            setProductIcon(authData?.icon);
            authData?.contacts.forEach((item, idx) => {
                setValue(`contacts.${idx}.name`, item.name);
                setValue(`contacts.${idx}.designation`, item.designation);
                setValue(`contacts.${idx}.countryCode`, item.countryCode);
                setValue(`contacts.${idx}.phoneNumber`, item.phoneNumber);
                setValue(`contacts.${idx}.email`, item.email);
                setValue(
                    `contacts.${idx}.smsNotification`,
                    item.smsNotification === 0 ? false : true
                );
                setValue(
                    `contacts.${idx}.emailNotification`,
                    item.emailNotification === 0 ? false : true
                );
                setValue(
                    `contacts.${idx}.isPrimary`,
                    item.isPrimary === 0 ? false : true
                );
            });
        }
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            await onAgentChange();
            axios.get("/agent-preference")
                .then((res) => {
                    const getEmails = [0, 1, 2].map((i) => ({
                        value: res.data.data[i]?.email || "",
                        error: false,
                        agent_id: res.data.data[i]?.agent_id || "",
                        agent_icon: res.data.data[i]?.agent_icon || "",
                    }));
                    setPriorities(getEmails);
                    getEmails.forEach((item, index) => {
                        setValue(`priorities.${index}.agent_id`, item.agent_id || "");
                    });
                })
                .catch((err) => {
                    console.error("Failed to fetch agent preferences", err);
                })
                .finally(() => {
                    setLoading(false);
                });
        };

        fetchData();
    }, []);


    //Store emails
    const handleUpdate = async () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const storeEmails = priorities
            .map(p => p.value.trim())
            .filter(email => email !== '');
        const invalidEmails = storeEmails.filter(email => !emailRegex.test(email));
        if (invalidEmails.length > 0) {
            toast.error(`Enter Valid email`);
            return;
        }
        const token = localStorage.getItem("dealerModuleToken");
        try {
            const response = await axios.post('/agent-preference', {
                emails: storeEmails
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });

            localStorage.setItem("agentEmailInfo", JSON.stringify(response.data.data));
            toast.success("Preferences updated successfully.");
        } catch (err) {
            console.error("Error in handleUpdate:", err);
            const error = err?.response?.data?.message || "Something went wrong";
            toast.error(error);
        }
    };

    //dropdown agents
    const onAgentChange = async () => {
        try {
            const response = await axios.get("agent-preference/dealers-info");
            const agentData = response?.data?.data || [];
            setAgentId(agentData);
        } catch (error) {
            console.error("Error fetching agents:", error);
        }
    }

    return (
        <div className="flex_adjust min-h-screen">
            <div className="flex justify-between items-center p-[16px_24px] border-b border-[#e3e3e3] bg-white" >
                <h2 className="text-[20px] font-[700] text-[#1a202c]">Profile</h2>
            </div>

            {loading ? (
                <div className="bg-white p-[20px] rounded-b-[10px]">
                    <LoaderComp />
                </div>
            ) : (
                <div className="bg-white p-[20px] rounded-b-[10px]">

                    <Tabs defaultActiveKey="1" className="w-full" tabBarStyle={{ display: 'flex', justifyContent: 'center', margin: '0px auto' }}>
                        <Tabs.TabPane tab="Profile" key="1">
                            <div>
                                {showCrop ? (
                                    <CropPopup
                                        image={image}
                                        setActive={setShowCrop}
                                        setImage={setCroppedImage}
                                    />
                                ) : null}
                            </div>

                            {editMode ? (
                                <div className="flex items-center gap-[10px]">
                                    <Button
                                        type="button"
                                        className="can_btn"
                                        onClick={() => setEditMode(false)}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        type="button"
                                        className="sav_btn"
                                        onClick={() => clickSubmitData("top_edit")}
                                    >
                                        {subBtnLoad && (
                                            <CircularProgress
                                                size={20}
                                                style={{ color: "white" }}
                                                className="mr-[13px]"
                                            />
                                        )}
                                        Save
                                    </Button>
                                </div>
                            ) : (
                                <Button
                                    type="button"
                                    className="sav_btn"
                                    style={{ float: "right" }}
                                    onClick={() => setEditMode(true)}
                                >
                                    Edit
                                </Button>
                            )}
                            <FormProvider {...methods}>
                                <div className="p-[32px_36px]">
                                    {editMode ? (
                                        <form
                                            className="profile_form w-[600px] max-w-full"
                                            onSubmit={handleSubmit(submitFormData)}
                                        >
                                            <div className="mb-[30px]">
                                                <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                    Full Name
                                                </label>
                                                <Controller
                                                    control={control}
                                                    name="name"
                                                    rules={{
                                                        required: true,
                                                    }}
                                                    render={({ field, fieldState }) => {
                                                        return (
                                                            <Input
                                                                {...field}
                                                                status={fieldState.error ? "error" : null}
                                                                placeholder="Enter Full Name"
                                                            />
                                                        );
                                                    }}
                                                />
                                            </div>
                                            <div className="mb-[30px]">
                                                <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                    {authData?.is_primary == 1 ? "Agent Email" : "Email"}
                                                </label>
                                                <Controller
                                                    control={control}
                                                    name="email"
                                                    rules={{
                                                        required: true,
                                                        pattern: {
                                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                            message: "*Invalid Email",
                                                        },
                                                    }}
                                                    render={({ field, fieldState }) => {
                                                        return (
                                                            <Input
                                                                {...field}
                                                                status={fieldState.error ? "error" : null}
                                                                placeholder="Enter Email address"
                                                            />
                                                        );
                                                    }}
                                                />
                                            </div>
                                            <div className="flex items-center gap-[0_10px] max-[600px]:flex-wrap">
                                                <div className="mb-[30px] w-[100px] max-[600px]:w-full">
                                                    <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                        Country Code*
                                                    </label>
                                                    <Controller
                                                        control={control}
                                                        name="countryCode"
                                                        rules={{
                                                            required: true,
                                                        }}
                                                        render={({ field, fieldState }) => {
                                                            return (
                                                                <Select
                                                                    {...field}
                                                                    showSearch
                                                                    status={fieldState.error ? "error" : null}
                                                                    suffixIcon={
                                                                        <img
                                                                            src="/images/select_ar.svg"
                                                                            alt="arrow"
                                                                            className="mr-[2px]"
                                                                        />
                                                                    }
                                                                    className="w-full"
                                                                >
                                                                    {countryCode.map((item, idx) => {
                                                                        return (
                                                                            <Select.Option key={idx} value={item.dial_code}>
                                                                                {item.dial_code}
                                                                            </Select.Option>
                                                                        );
                                                                    })}
                                                                </Select>
                                                            );
                                                        }}
                                                    />
                                                </div>
                                                <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                                                    <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                        Contact Number
                                                    </label>
                                                    <Controller
                                                        control={control}
                                                        name="phoneNumber"
                                                        rules={{
                                                            required: true,
                                                        }}
                                                        render={({ field, fieldState }) => {
                                                            return (
                                                                <Input
                                                                    {...field}
                                                                    status={fieldState.error ? "error" : null}
                                                                    placeholder="Contact Number"
                                                                />
                                                            );
                                                        }}
                                                    />
                                                </div>
                                                {authData?.is_primary == 1 && (
                                                    <div className="mb-[30px] w-[184px] max-[600px]:w-full">
                                                        <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                            Fax Number
                                                        </label>
                                                        <Controller
                                                            control={control}
                                                            name="faxNumber"
                                                            render={({ field }) => {
                                                                return <Input {...field} placeholder="Fax Number" />;
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>

                                            {authData?.is_primary == 1 && (
                                                <>
                                                    <div
                                                        className={authData?.is_primary !== 1 && "pointer-events-none"}
                                                    >
                                                        <h4 className="text-[#1a202c] text-[14px] font-[600] mb-[20px]">
                                                            Agent Details
                                                        </h4>
                                                        <div>
                                                            <div className="mb-[30px]">
                                                                <label
                                                                    className="block mb-[4px] text-[13px] text-[#798188]"
                                                                    ref={imgPosRef}
                                                                >
                                                                    Agent's Logo
                                                                </label>
                                                                <ImageInput
                                                                    error={imgErr}
                                                                    image={
                                                                        croppedImage
                                                                            ? croppedImage
                                                                            : productIcon && productIcon !== ""
                                                                                ? `${IMAGE_BASE_URL}/${productIcon}`
                                                                                : ""
                                                                    }
                                                                    setImage={onImageChange}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center gap-[0_10px] max-[600px]:flex-wrap">
                                                            <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                                                                <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                                    Agent Company Name
                                                                </label>
                                                                <Controller
                                                                    control={control}
                                                                    name="name"
                                                                    rules={{
                                                                        required: true,
                                                                    }}
                                                                    render={({ field, fieldState }) => {
                                                                        return (
                                                                            <Input
                                                                                {...field}
                                                                                status={fieldState.error ? "error" : null}
                                                                                placeholder="Enter Company Name"
                                                                                disabled={editMode}
                                                                            />
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="mb-[30px] w-[184px] max-[600px]:w-full">
                                                                <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                                    UEN Number
                                                                </label>
                                                                <Controller
                                                                    control={control}
                                                                    name="uenNumber"
                                                                    rules={{
                                                                        required: true,
                                                                    }}
                                                                    render={({ field, fieldState }) => {
                                                                        return (
                                                                            <Input
                                                                                {...field}
                                                                                status={fieldState.error ? "error" : null}
                                                                                placeholder="UEN Number"
                                                                                disabled={editMode}
                                                                            />
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="mb-[30px]">
                                                            <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                                Address
                                                            </label>
                                                            <Controller
                                                                control={control}
                                                                name="addressLine1"
                                                                rules={{
                                                                    required: true,
                                                                }}
                                                                render={({ field, fieldState }) => {
                                                                    return (
                                                                        <Input
                                                                            {...field}
                                                                            status={fieldState.error ? "error" : null}
                                                                            placeholder="Address 1 ( Floor, Unit No., Street Name)"
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="mb-[30px]">
                                                            <Controller
                                                                control={control}
                                                                name="addressLine2"
                                                                rules={{
                                                                    required: true,
                                                                }}
                                                                render={({ field, fieldState }) => {
                                                                    return (
                                                                        <Input
                                                                            {...field}
                                                                            status={fieldState.error ? "error" : null}
                                                                            placeholder="Address 2 (Building name, other info)"
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="flex items-center gap-[0_10px] max-[600px]:flex-wrap">
                                                            <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                                                                <Controller
                                                                    control={control}
                                                                    name="postalCode"
                                                                    rules={{
                                                                        required: true,
                                                                    }}
                                                                    render={({ field, fieldState }) => {
                                                                        return (
                                                                            <Input
                                                                                {...field}
                                                                                status={fieldState.error ? "error" : null}
                                                                                placeholder="Postal Code"
                                                                            />
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                                                                <Controller
                                                                    control={control}
                                                                    name="country"
                                                                    rules={{
                                                                        required: true,
                                                                    }}
                                                                    render={({ field, fieldState }) => {
                                                                        return (
                                                                            <Select
                                                                                {...field}
                                                                                showSearch
                                                                                status={fieldState.error ? "error" : null}
                                                                                suffixIcon={
                                                                                    <img
                                                                                        src="/images/select_ar.svg"
                                                                                        alt="arrow"
                                                                                        className="mr-[2px]"
                                                                                    />
                                                                                }
                                                                                className="w-full"
                                                                            >
                                                                                {countryCode.map((item, idx) => {
                                                                                    return (
                                                                                        <Select.Option key={idx} value={item.code}>
                                                                                            {item.name}
                                                                                        </Select.Option>
                                                                                    );
                                                                                })}
                                                                            </Select>
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <h4 className="text-[#1a202c] text-[14px] font-[600] mb-[20px]">
                                                            Contacts
                                                        </h4>
                                                        <ContactCard />
                                                        {/* <Tabs
                                    items={rat_items}
                                    defaultActiveKey={ratingsTab}
                                    onChange={(k) => setratingsTab(k)}
                                />
                                {ratingsTab === 0 ? authData?.is_primary == 1 && (
                                    <>
                                       
                                    </>
                                ) : (
                                    <div className="h-[30px]"></div>
                                )} */}
                                                    </div>
                                                    <div className="flex items-center gap-[10px] mt-5">
                                                        <Button
                                                            type="button"
                                                            className="can_btn profile_cn"
                                                            onClick={() => setEditMode(false)}
                                                        >
                                                            Cancel
                                                        </Button>
                                                        <Button
                                                            type="sumbit"
                                                            className="sav_btn"
                                                            onClick={clickSubmitData}
                                                        >
                                                            {subBtnLoad && (
                                                                <CircularProgress
                                                                    size={20}
                                                                    style={{ color: "white" }}
                                                                    className="mr-[13px]"
                                                                />
                                                            )}
                                                            Save
                                                        </Button>
                                                    </div>
                                                </>
                                            )}

                                        </form>
                                    ) : (
                                        <div className="profile_view w-[600px] max-w-full">
                                            <div className="flex items-center gap-[0_10px] max-[600px]:flex-wrap">
                                                <div className="mb-[30px] flex-[1] max-[400px]:flex-[unset] max-[400px]:w-full">
                                                    <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                        Created On
                                                    </label>
                                                    <p className="text-[13px]">
                                                        {dayjs(authData.created_at).format("DD-MM-YYYY HH:MM")}
                                                    </p>
                                                </div>
                                                <div className="mb-[30px] flex-[1] max-[400px]:flex-[unset] max-[400px]:w-full">
                                                    <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                        Updated On
                                                    </label>
                                                    <p className="text-[13px]">
                                                        {dayjs(authData.updated_at).format("DD-MM-YYYY HH:MM")}
                                                    </p>
                                                </div>
                                            </div>
                                            {authData?.is_primary == 1 && (
                                                <div className="mb-[30px]">
                                                    <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                        Agent Status
                                                    </label>
                                                    <p className="text-[13px]">
                                                        {authData.status == 0
                                                            ? "Pending"
                                                            : authData.status == 1
                                                                ? "Approved"
                                                                : authData.status == 2
                                                                    ? "Rejected"
                                                                    : authData.status == 3
                                                                        ? "Banned"
                                                                        : ""}
                                                    </p>
                                                </div>
                                            )}
                                            <div className="mb-[30px]">
                                                <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                    Full Name
                                                </label>
                                                <p className="text_place">{authData.name}</p>
                                            </div>
                                            <div className="mb-[30px]">
                                                <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                    {authData?.is_primary == 1 ? "Agent Email" : "Email"}
                                                </label>
                                                <p className="text_place">{authData.email}</p>
                                            </div>
                                            <div className="flex items-center gap-[0_10px] max-[600px]:flex-wrap">
                                                <div className="mb-[30px] w-[150px] max-[600px]:w-full">
                                                    <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                        Country Code*
                                                    </label>
                                                    <p className="text_place">{authData.countryCode}</p>
                                                </div>
                                                <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                                                    <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                        Contact Number
                                                    </label>
                                                    <p className="text_place">{authData.phoneNumber}</p>
                                                </div>
                                                {authData?.is_primary == 1 && (
                                                    <div className="mb-[30px] w-[184px] max-[600px]:w-full">
                                                        <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                            Fax Number
                                                        </label>
                                                        <p className="text_place">{authData.faxNumber}</p>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="mb-[30px]">
                                                <label className="flex justify-between items-center mb-[4px] text-[13px] text-[#798188]">
                                                    Password
                                                </label>
                                                <p className="text_place">*********</p>
                                            </div>
                                            {authData?.is_primary == 1 && (
                                                <>
                                                    <h4 className="text-[#1a202c] text-[14px] font-[600] mb-[20px]">
                                                        Agent Details
                                                    </h4>
                                                    <div className="flex flex-wrap gap-[0_10px]">
                                                        <div className="mb-[30px] w-full">
                                                            <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                                Agent's Logo
                                                            </label>
                                                            <img
                                                                src={`${IMAGE_BASE_URL}/${productIcon}`}
                                                                alt="profile"
                                                                className="w-[30px] h-[30px] object-contain mt-[10px]"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-[0_10px] max-[600px]:flex-wrap">
                                                        <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                                                            <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                                Agent Company Name
                                                            </label>
                                                            <p className="text_place">{authData.name}</p>
                                                        </div>
                                                        <div className="mb-[30px] w-[184px] max-[600px]:w-full">
                                                            <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                                UEN Number
                                                            </label>
                                                            <p className="text_place">{authData.uenNumber}</p>
                                                        </div>
                                                    </div>
                                                    <div className="mb-[30px]">
                                                        <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                            Address Line 1
                                                        </label>
                                                        <p className="text_place">{authData.addressLine1}</p>
                                                    </div>
                                                    <div className="mb-[30px]">
                                                        <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                            Address Line 2
                                                        </label>
                                                        <p className="text_place">{authData.addressLine2}</p>
                                                    </div>
                                                    <div className="flex items-center gap-[0_10px] max-[600px]:flex-wrap">
                                                        <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                                                            <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                                Postal Code
                                                            </label>
                                                            <p className="text_place">{authData.postalCode}</p>
                                                        </div>
                                                        <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                                                            <label className="block mb-[4px] text-[13px] text-[#798188]">
                                                                Country
                                                            </label>
                                                            <p className="text_place">
                                                                {/* {authData.country} */}
                                                                Singapore
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <h4 className="text-[#1a202c] text-[14px] font-[600] mb-[20px]">
                                                        Contacts
                                                    </h4>
                                                    <ContactCard viewMode={true} />
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </FormProvider>
                        </Tabs.TabPane>

                        <Tabs.TabPane tab="Security" key="2">
                            <div className="p-[32px_36px]">

                                <form
                                    className="profile_form max-w-full"
                                    onSubmit={handleSubmit(submitFormData)}
                                >
                                    <h2 style={{ borderBottom: "solid 2px #000", marginBottom: "20px", padding: "0px 0px 5px 0px", fontWeight: 500, fontSize: "15px" }}>Change Password</h2>


                                    <div className="flex flex-wrap gap-[0_10px] w-[600px]" ref={pwdPosRef}>
                                        <div className="mb-[30px] flex-[1]">
                                            <label className="flex justify-between items-center mb-[4px] text-[13px] text-[#798188]">
                                                Password
                                                {!resPassword && (
                                                    <span
                                                        className="text-blue-600 font-medium cursor-pointer"
                                                        onClick={() => setresPassword(true)}
                                                    >
                                                        Set Password
                                                    </span>
                                                )}
                                            </label>
                                            <Input
                                                status={pwdData.pwdError ? "error" : null}
                                                value={pwdData.password}
                                                onChange={(e) =>
                                                    setpwdData({ ...pwdData, password: e.target.value })
                                                }
                                                type="password"
                                                placeholder="Enter Password"
                                            />
                                        </div>
                                        {resPassword && (
                                            <div className="mb-[30px] w-[210px]">
                                                <label className="flex justify-between items-center mb-[4px] text-[13px] text-[#798188]">
                                                    Confirm Password
                                                </label>
                                                <Input
                                                    status={pwdData.cpwdError ? "error" : null}
                                                    value={pwdData.cnfirm_pwd}
                                                    onChange={(e) =>
                                                        setpwdData({ ...pwdData, cnfirm_pwd: e.target.value })
                                                    }
                                                    type="password"
                                                    placeholder="Confirm Password"
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <h2 style={{ borderBottom: "solid 2px #000", marginTop: "30px", marginBottom: "20px", padding: "0px 0px 5px 0px", fontWeight: 500, fontSize: "15px" }}> Security <span className="text-blue-500 cursor-pointer">ℹ️</span></h2>
                                    <div className="rounded bg-white max-w-[300px]">

                                        <div className="flex justify-between items-center text-[#4a5568] mb-[10px]">
                                            <span>Secret PIN</span>
                                            <span>{formatTime()}</span>
                                        </div>
                                        <div className="text-[28px] font-bold text-[#2d3748] tracking-widest mb-[16px]">{pin}</div>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            disabled={disabled}
                                            onClick={handleResendPin}
                                            style={{ backgroundColor: disabled ? "#ccc" : "#0560fb", textTransform: 'capitalize' }}
                                        >
                                            Generate PIN
                                        </Button>
                                    </div>
                                </form>
                            </div>


                        </Tabs.TabPane>


                        <Tabs.TabPane tab="Configuration" key="3">
                            <div className="p-[32px_36px]">

                                <form
                                    className="profile_form max-w-full"
                                    onSubmit={handleSubmit(submitFormData)}
                                >
                                    <h2 style={{ borderBottom: "solid 2px #000", marginBottom: "20px", padding: "0px 0px 5px 0px", fontWeight: 500, fontSize: "15px" }}>Set Default Agent <span className="text-blue-500 cursor-pointer">ℹ️</span></h2>

                                    {priorities && priorities.map((priority, index) => {
                                        const selectedAgentIds = priorities
                                            .filter((_, i) => i !== index)
                                            .map(p => p.agent_id)
                                            .filter(Boolean);

                                        // Initial list disable handling
                                        const filteredOptions = agentId.map(agent => ({
                                            ...agent,
                                            disabled: selectedAgentIds.includes(agent.id),
                                        }));

                                        return (
                                            <div key={index} className="flex flex-wrap gap-[0_10px] w-[600px]">
                                                <div className="mb-[30px] flex-[1]">
                                                    <label className="flex justify-between items-center mb-[4px] text-[14px] text-[#798188]">
                                                        {getLabel(index)}
                                                    </label>
                                                    <Controller
                                                        control={control}
                                                        name={`priorities.${index}.agent_id`}
                                                        rules={{ required: true }}
                                                        render={({ field }) => (
                                                            <CustomImageSelect
                                                                error={errors?.priorities?.[index]?.agent_id}
                                                                name={field.name}
                                                                placeholder="Search Agent"
                                                                onOpen={onAgentChange}
                                                                onSelect={(agent) => {
                                                                    if (agent) {
                                                                        field.onChange(agent.id);
                                                                        handleChange(index, agent.email);
                                                                        setPriorities(prev => {
                                                                            const updated = [...prev];
                                                                            updated[index] = {
                                                                                ...updated[index],
                                                                                agent_id: agent.id,
                                                                                value: agent.email
                                                                            };
                                                                            return updated;
                                                                        });
                                                                    } else {
                                                                        field.onChange(null);
                                                                        handleChange(index, "");
                                                                        setPriorities(prev => {
                                                                            const updated = [...prev];
                                                                            updated[index] = {
                                                                                ...updated[index],
                                                                                agent_id: null,
                                                                                value: ""
                                                                            };
                                                                            return updated;
                                                                        });
                                                                    }
                                                                }}
                                                                value={field.value}
                                                                disabled={isFormEdit}
                                                                options={filteredOptions}  // ✅ use filteredOptions here
                                                                onSearch={async (query) => {
                                                                    if (searchTimeout) clearTimeout(searchTimeout);

                                                                    return new Promise((resolve) => {
                                                                        searchTimeout = setTimeout(async () => {
                                                                            try {
                                                                                const res = await axios.get(
                                                                                    "/agent-preference/dealers-info",
                                                                                    { params: { search: query } }
                                                                                );

                                                                                const data = res.data?.data || [];
                                                                                resolve(
                                                                                    data.map((a, i) => ({
                                                                                        ...a,
                                                                                        value: a.email || "",
                                                                                        error: false,
                                                                                        agent_id: a.id || "",
                                                                                        agent_icon: a.icon || "",
                                                                                        disabled: selectedAgentIds.includes(a.id), // ✅ disable in search results too
                                                                                    }))
                                                                                );
                                                                            } catch (error) {
                                                                                console.error("Error fetching agents:", error);
                                                                                resolve([]);
                                                                            }
                                                                        }, 500);
                                                                    });
                                                                }}
                                                                allowClear={true}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        );
                                    })}



                                    <div className="w-[600px]">
                                        <Button
                                            type="button"
                                            className="sav_btn"
                                            onClick={handleUpdate}
                                        >
                                            Update
                                        </Button>
                                    </div>
                                </form>
                            </div>


                        </Tabs.TabPane>

                    </Tabs>
                </div>
            )}
        </div>
    );
};
export const CustomImageSelect = ({
    disabled,
    onSelect,
    options,
    value,
    placeholder,
    error,
    onOpen,
    onSearch, // async function: searchText => API call returning array of agents
}) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [filteredOptions, setFilteredOptions] = useState(options || []);
    const containerRef = useRef(null);

    // Update selected option from value
    useEffect(() => {
        if (!value || !options?.length) {
            setSelectedOption(null);
            return;
        }
        const selected = options.find((o) => o.id === value);
        setSelectedOption(selected || null);
    }, [value, options]);

    // Handle search text changes
    useEffect(() => {
        if (searchText && typeof onSearch === "function") {
            setIsOpen(false); // close before showing results
            onSearch(searchText).then((results) => {
                if (results.length > 0) {
                    setIsOpen(true);
                    setFilteredOptions(results);
                } else {
                    setIsOpen(true);
                    setFilteredOptions([]); // empty means "no data"
                }
            });
        } else {
            // when no search, show default options
            setFilteredOptions(options || []);
        }
    }, [searchText, options, onSearch]);

    // Click outside closes dropdown
    const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleOptionClick = (option) => {
        if (option.disabled) return;
        setIsOpen(false);
        onSelect(option);
        setSearchText(""); // reset search after selection
    };

    const handleClearSelection = (e) => {
        e.stopPropagation();
        setSelectedOption(null);
        onSelect(null);
    };

    const handleClearSearch = (e) => {
        e.stopPropagation();
        setSearchText("");
    };

    const handlePlaceholderClick = () => {
        if (disabled) return;
        if (!searchText) {
            setIsOpen((prev) => !prev);
            if (!isOpen && typeof onOpen === "function") onOpen();
        }
    };

    return (
        <div className="relative w-full h-[2.5rem]" ref={containerRef}>
            <div
                onClick={handlePlaceholderClick}
                className={`select-section flex items-center bg-white border border-1 text-gray-700 py-2 px-4 rounded-md leading-tight w-full 
        ${disabled ? "opacity-50" : "opacity-100"}
        ${error ? "error-shadow" : "border-[#E2E8F0]"}
        `}
            >
                <div className="flex h-[24px] items-center w-full justify-between">
                    <div className="flex items-center w-full relative">
                        {selectedOption ? (
                            <>
                                <img
                                    src={`${IMAGE_BASE_URL}/${selectedOption.icon}`}
                                    alt=""
                                    className="h-[24px] w-[24px] rounded mr-2"
                                />
                                <p className="text">{selectedOption.email}</p>
                            </>
                        ) : (
                            <input
                                type="text"
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                placeholder={placeholder}
                                className="w-full outline-none text-[13px] text-gray-500"
                                onClick={(e) => e.stopPropagation()} // prevent dropdown toggle
                                disabled={disabled}
                            />
                        )}

                        {/* Clear search */}
                        {searchText && !selectedOption && (
                            <button
                                onClick={handleClearSearch}
                                className="absolute right-6 text-gray-400 text-sm"
                                title="Clear search"
                            >
                                ✕
                            </button>
                        )}
                    </div>

                    {/* Clear selected */}
                    {selectedOption && !disabled && (
                        <button
                            onClick={handleClearSelection}
                            className="text-red-500 text-sm ml-2"
                            title="Clear selection"
                        >
                            ✕
                        </button>
                    )}

                    <IoMdArrowDropdown
                        className={`ml-2 ${isOpen ? "transform rotate-180" : ""}`}
                    />
                </div>
            </div>

            {/* Dropdown */}
            {isOpen && (
                <div className="z-10 absolute mt-1 bg-white border border-gray-300 rounded shadow-lg w-full max-h-[200px] overflow-y-auto">
                    {filteredOptions.length > 0 ? (
                        filteredOptions.map((option) => (
                            <div
                                key={option.id}
                                className={`flex w-full items-center px-4 py-2 cursor-pointer hover:bg-gray-100 ${option.disabled ? "opacity-40 cursor-not-allowed hover:bg-white" : ""
                                    }`}
                                onClick={() => handleOptionClick(option)}
                            >
                                <img
                                    src={`${IMAGE_BASE_URL}/${option.icon}`}
                                    alt=""
                                    className="h-[26px] w-[26px] rounded mr-2"
                                />
                                <p className="text">{option.name}</p>&nbsp;-&nbsp;&nbsp;
                                <p className="text">{option.email}</p>
                            </div>
                        ))
                    ) : (
                        <div className="px-4 py-2 text-gray-500 text-sm">No agent</div>
                    )}
                </div>
            )}
        </div>
    );
};




export default Profile;
